import { render, staticRenderFns } from "./SourceCover.vue?vue&type=template&id=71c37be8&scoped=true&"
import script from "./SourceCover.vue?vue&type=script&lang=js&"
export * from "./SourceCover.vue?vue&type=script&lang=js&"
import style0 from "./SourceCover.vue?vue&type=style&index=0&id=71c37be8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c37be8",
  null
  
)

export default component.exports